"use strict";
import { AddressDisplay } from "components/AccountDetails/AddressDisplay";
import { CopyHelper } from "theme/components/CopyHelper";
import { Flex, QRCodeDisplay, Text, useSporeColors } from "ui/src";
import { useAddressColorProps } from "features/address/color";
import { useENSName } from "features/ens/api";
import { useUnitagByAddress } from "features/unitags/hooks";
import { shortenAddress } from "utilities/src/addresses";
import { WalletIcon } from "components/Identicon";
const UNICON_SIZE = 50;
const QR_CODE_SIZE = 230;
export function AddressQRCode({ accountAddress }) {
  const colors = useSporeColors();
  const { data: ENSName } = useENSName(accountAddress);
  const { unitag } = useUnitagByAddress(accountAddress);
  const hasSecondaryIdentifier = ENSName || unitag?.username;
  const addressColor = useAddressColorProps(accountAddress);
  return <Flex pt="$spacing8" gap="$spacing16">
      <Flex gap="$spacing12">
        <Flex alignItems="center">
          <Text variant="heading3">
            <AddressDisplay enableCopyAddress={!hasSecondaryIdentifier} address={accountAddress} />
          </Text>
          {hasSecondaryIdentifier && <CopyHelper color="$neutral2" iconSize={14} iconPosition="right" toCopy={accountAddress}>
              <Text variant="body3" color="neutral2">
                {shortenAddress(accountAddress)}
              </Text>
            </CopyHelper>}
        </Flex>
        <QRCodeDisplay
    ecl="M"
    color={addressColor}
    containerBackgroundColor={colors.surface1.val}
    size={QR_CODE_SIZE}
    encodedValue={accountAddress}
  >
          <Flex
    justifyContent="center"
    alignItems="center"
    p="$spacing4"
    backgroundColor="$surface1"
    borderRadius="$roundedFull"
  >
            <WalletIcon size={UNICON_SIZE} />
          </Flex>
        </QRCodeDisplay>
        
      </Flex>
    </Flex>;
}
